import type { PropsWithChildren } from "react";
import { getHomepageUrl } from "src/services/configService";
import { makeStyles } from "tss-react/mui";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Box } from "@mui/material";
import ApmLink from "@shared/ApmLink";
import { Logo } from "@shared/Logo/Logo";

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    logoLink: {
        marginBottom: theme.spacing(16),
        display: "block",
    },
    content: {
        width: "100%",
        maxWidth: 400,
    },
}));

export const AuthFlowContainer = ({ children }: PropsWithChildren) => {
    const { classes } = useStyles();

    return (
        <PageContainer className={classes.container}>
            <ApmLink href={getHomepageUrl()} className={classes.logoLink}>
                <Logo variant="full" />
            </ApmLink>
            <Box className={classes.content}>{children}</Box>
        </PageContainer>
    );
};
